import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';
import type { CSSProperties, ReactNode } from 'react';
import Iconify from '../../../components/iconify/component';
import type { IconifyProps } from '../../../components/iconify/types';
import { checkUndefinedNullOrEmpty } from '../../Tools';

type InputNonEditValueProps = {
    alignItems?: CSSProperties['alignItems'];
    autoWidth?: boolean;
    endIcon?: IconifyProps;
    fatLabel?: boolean;
    finalId: string;
    hideLabel: boolean;
    icon?: IconifyProps;
    info?: string;
    l?: string;
    loading?: boolean;
    textAlign?: CSSProperties['textAlign'];
    value: ReactNode;
    valueSx?: SxProps<Theme>;
};

export default function InputNonEditValue(props: InputNonEditValueProps) {
    const { alignItems, autoWidth, endIcon, fatLabel, finalId, hideLabel, icon, info, l, loading, textAlign, value, valueSx } = props;
    const hasHeading = !hideLabel && (!checkUndefinedNullOrEmpty(l) || !checkUndefinedNullOrEmpty(icon) || !checkUndefinedNullOrEmpty(info) || !checkUndefinedNullOrEmpty(endIcon));

    return (
        <Stack
            data-testid={finalId}
            alignItems={alignItems || 'center'}
            direction="row"
            justifyContent={textAlign === 'right' ? 'flex-end' : textAlign === 'center' ? 'center' : textAlign === 'justify' ? 'space-between' : 'flex-start'}
            sx={{
                width: !autoWidth ? 1 : undefined,
            }}
        >
            {hasHeading && (
                <>
                    <Stack alignItems={alignItems || 'center'} direction="row" gap={0.5} justifyContent="inherit" sx={{ lineHeight: 1 }}>
                        {!checkUndefinedNullOrEmpty(icon) ? <Iconify icon={icon} sx={{ flexShrink: 0 }} /> : undefined}
                        {!checkUndefinedNullOrEmpty(l) ? (
                            <Typography fontWeight={fatLabel ? 700 : undefined} textAlign={textAlign} variant="body1" whiteSpace="pre">
                                {l}
                            </Typography>
                        ) : undefined}
                        {!checkUndefinedNullOrEmpty(endIcon) ? <Iconify icon={endIcon} sx={{ flexShrink: 0 }} /> : undefined}
                        {!checkUndefinedNullOrEmpty(info) ? (
                            <Tooltip title={info}>
                                <Iconify color="primary.main" icon="mdi:info" sx={{ flexShrink: 0 }} />
                            </Tooltip>
                        ) : undefined}
                    </Stack>
                    <Typography fontWeight={fatLabel ? 700 : undefined} textAlign={textAlign} variant="body1" whiteSpace="pre">
                        :
                    </Typography>
                </>
            )}
            {loading === true ? (
                <Skeleton animation="wave" width="100%" height="calc(1em + 8px)" sx={{ ml: hasHeading ? 1 : undefined }} />
            ) : typeof value === 'string' ? (
                <Typography sx={{ ...valueSx, ml: hasHeading ? 1 : undefined }} textAlign={textAlign} variant="body1">
                    {value}
                </Typography>
            ) : (
                <Box sx={{ ...valueSx, width: 1, ml: hasHeading ? 1 : undefined }}>{value}</Box>
            )}
        </Stack>
    );
}
